export default {
	SupplierAcceptTaxAuthorities: [],
	Total: 0,
	SupplierAcceptTaxAuthority: {},
	IsLoadingData: false
};
